import React from "react";
import { List, Row, Col, Typography } from "antd";
import { ListRecordAttributeItem } from 'components';
import { formatApiKeyDateTime } from "common/apiKeys";

const { Title, Text } = Typography;

const displayLabels = {
    "name": "Name",
    "description": "Description",
    "maskedKey": "Key",
    "active": "Active",
    "expiresAt": "Expires",
    "lastUsedDate": "Last used",
    "updatedByEmail": "Updated by",
    "updatedDate": "Updated at",
    "deleted": "Deleted"
}

const dateAttributes = ["expiresAt", "lastUsedDate", "updatedDate"];

export default function ({ record }) {
    return <>
        <Row className="middle-row">
            <Col span={24}>
                <Title level={5}><Text>{record.name}</Text></Title>
            </Col>
        </Row>
        <Row>
            <Col span={24}>
                <List
                    size="small"
                    bordered
                    dataSource={Object.keys(record.data)}
                    renderItem={item => {
                        if (displayLabels[item]) {
                            if (dateAttributes.includes(item)) {
                                return <ListRecordAttributeItem name={displayLabels[item]} value={formatApiKeyDateTime(record.data[item])} previousValue={record.previousData && record.previousData[item] !== undefined && formatApiKeyDateTime(record.previousData[item])}></ListRecordAttributeItem>
                            }
                            return <ListRecordAttributeItem name={displayLabels[item]} value={record.data[item]} previousValue={record.previousData && record.previousData[item]}></ListRecordAttributeItem>
                        }
                        return <></>
                    }}
                />
            </Col>
        </Row>
    </>
}
